var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_634_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 166C135.899 166 165 136.899 165 101C165 65.1015 135.899 36 100 36C64.1015 36 35 65.1015 35 101C35 136.899 64.1015 166 100 166Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3398 59.2269H172.106V141.367C172.106 147.727 166.947 152.887 160.587 152.887H37.1064C31.7198 152.887 27.3465 148.513 27.3465 143.127V59.2269H27.3398Z",
    fill: "white",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08 51H41.6866C36.3368 51 32 55.3369 32 60.6867V147.533C32 152.883 36.3368 157.22 41.6866 157.22H167.08C172.43 157.22 176.767 152.883 176.767 147.533V60.6867C176.767 55.3369 172.43 51 167.08 51Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6533 46.6667H163.867C168.413 46.6667 172.1 50.3534 172.1 54.9001V59.2267H27.3333V56.98C27.3333 51.2867 31.9533 46.6667 37.6467 46.6667H37.6533Z",
    fill: "#5378FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.42 46.6667H37.0264C31.6767 46.6667 27.3398 51.0036 27.3398 56.3534V143.2C27.3398 148.55 31.6767 152.887 37.0264 152.887H162.42C167.77 152.887 172.106 148.55 172.106 143.2V56.3534C172.106 51.0036 167.77 46.6667 162.42 46.6667Z",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3398 59.2269H172.1",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6933 55.5132C38.1108 55.5132 39.26 54.364 39.26 52.9465C39.26 51.5289 38.1108 50.3799 36.6933 50.3799C35.2757 50.3799 34.1266 51.5289 34.1266 52.9465C34.1266 54.364 35.2757 55.5132 36.6933 55.5132Z",
    fill: "#3D5199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7599 55.5132C47.1775 55.5132 48.3266 54.364 48.3266 52.9465C48.3266 51.5289 47.1775 50.3799 45.7599 50.3799C44.3424 50.3799 43.1932 51.5289 43.1932 52.9465C43.1932 54.364 44.3424 55.5132 45.7599 55.5132Z",
    fill: "#3D5199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8333 55.5132C56.2508 55.5132 57.3999 54.364 57.3999 52.9465C57.3999 51.5289 56.2508 50.3799 54.8333 50.3799C53.4157 50.3799 52.2666 51.5289 52.2666 52.9465C52.2666 54.364 53.4157 55.5132 54.8333 55.5132Z",
    fill: "#3D5199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 75.6533H155.92",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 100.707H155.92",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 84.9066H115.093",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 109.96H115.093",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 126.14H155.92",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 135.4H115.093",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5532 80.1468C46.6999 80.1468 43.1999 82.1602 43.1999 83.3202V87.2935C43.1999 88.4601 46.6999 90.4668 49.5532 90.4668C52.4066 90.4668 55.9066 88.4535 55.9066 87.2935V83.3202C55.9066 82.1535 52.4066 80.1468 49.5532 80.1468Z",
    fill: "#36A635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9066 87.2935V83.3202C55.9066 82.1535 52.4066 80.1468 49.5532 80.1468C46.6999 80.1468 43.1999 82.1602 43.1999 83.3202V87.2935",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5465 80.1466C51.9332 80.1466 53.5199 78.1667 53.5199 75.72V74.2467C53.5199 71.8001 51.9399 69.82 49.5465 69.82C47.1532 69.82 45.5732 71.8001 45.5732 74.2467V75.72C45.5732 78.1667 47.1532 80.1466 49.5465 80.1466Z",
    fill: "white",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5532 106.06C46.6999 106.06 43.1999 108.074 43.1999 109.234V113.207C43.1999 114.374 46.6999 116.38 49.5532 116.38C52.4066 116.38 55.9066 114.367 55.9066 113.207V109.234C55.9066 108.067 52.4066 106.06 49.5532 106.06Z",
    fill: "#36A635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9066 113.207V109.234C55.9066 108.067 52.4066 106.06 49.5532 106.06C46.6999 106.06 43.1999 108.074 43.1999 109.234V113.207",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5465 106.06C51.9332 106.06 53.5199 104.08 53.5199 101.633V100.16C53.5199 97.7133 51.9399 95.7334 49.5465 95.7334C47.1532 95.7334 45.5732 97.7133 45.5732 100.16V101.633C45.5732 104.08 47.1532 106.06 49.5465 106.06Z",
    fill: "white",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5532 131.973C46.6999 131.973 43.1999 133.987 43.1999 135.147V139.12C43.1999 140.287 46.6999 142.293 49.5532 142.293C52.4066 142.293 55.9066 140.28 55.9066 139.12V135.147C55.9066 133.98 52.4066 131.973 49.5532 131.973Z",
    fill: "#36A635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9066 139.12V135.147C55.9066 133.98 52.4066 131.973 49.5532 131.973C46.6999 131.973 43.1999 133.987 43.1999 135.147V139.12",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5465 131.973C51.9332 131.973 53.5199 129.994 53.5199 127.547V126.074C53.5199 123.627 51.9399 121.647 49.5465 121.647C47.1532 121.647 45.5732 123.627 45.5732 126.074V127.547C45.5732 129.994 47.1532 131.973 49.5465 131.973Z",
    fill: "white",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3398 59.2269H172.106V141.367C172.106 147.727 166.947 152.887 160.587 152.887H37.1064C31.7198 152.887 27.3465 148.513 27.3465 143.127V59.2269H27.3398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6533 46.6667H163.867C168.413 46.6667 172.1 50.3534 172.1 54.9001V59.2267H27.3333V56.98C27.3333 51.2867 31.9533 46.6667 37.6467 46.6667H37.6533Z",
    fill: "#36A635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.42 46.6667H37.0264C31.6767 46.6667 27.3398 51.0036 27.3398 56.3534V143.2C27.3398 148.55 31.6767 152.887 37.0264 152.887H162.42C167.77 152.887 172.106 148.55 172.106 143.2V56.3534C172.106 51.0036 167.77 46.6667 162.42 46.6667Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3398 59.2269H172.1",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6933 55.5132C38.1108 55.5132 39.26 54.364 39.26 52.9465C39.26 51.5289 38.1108 50.3799 36.6933 50.3799C35.2757 50.3799 34.1266 51.5289 34.1266 52.9465C34.1266 54.364 35.2757 55.5132 36.6933 55.5132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7599 55.5132C47.1775 55.5132 48.3266 54.364 48.3266 52.9465C48.3266 51.5289 47.1775 50.3799 45.7599 50.3799C44.3424 50.3799 43.1932 51.5289 43.1932 52.9465C43.1932 54.364 44.3424 55.5132 45.7599 55.5132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8333 55.5132C56.2508 55.5132 57.3999 54.364 57.3999 52.9465C57.3999 51.5289 56.2508 50.3799 54.8333 50.3799C53.4157 50.3799 52.2666 51.5289 52.2666 52.9465C52.2666 54.364 53.4157 55.5132 54.8333 55.5132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 75.6533H155.92",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 100.707H155.92",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 84.9066H115.093",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 109.96H115.093",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 126.14H130.867",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0732 135.4H115.093",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5532 80.1468C46.6999 80.1468 43.1999 82.1602 43.1999 83.3202V87.2935C43.1999 88.4601 46.6999 90.4668 49.5532 90.4668C52.4066 90.4668 55.9066 88.4535 55.9066 87.2935V83.3202C55.9066 82.1535 52.4066 80.1468 49.5532 80.1468Z",
    fill: "#36A635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9066 87.2935V83.3202C55.9066 82.1535 52.4066 80.1468 49.5532 80.1468C46.6999 80.1468 43.1999 82.1602 43.1999 83.3202V87.2935",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5465 80.1466C51.9332 80.1466 53.5199 78.1667 53.5199 75.72V74.2467C53.5199 71.8001 51.9399 69.82 49.5465 69.82C47.1532 69.82 45.5732 71.8001 45.5732 74.2467V75.72C45.5732 78.1667 47.1532 80.1466 49.5465 80.1466Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5532 106.06C46.6999 106.06 43.1999 108.074 43.1999 109.234V113.207C43.1999 114.374 46.6999 116.38 49.5532 116.38C52.4066 116.38 55.9066 114.367 55.9066 113.207V109.234C55.9066 108.067 52.4066 106.06 49.5532 106.06Z",
    fill: "#36A635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9066 113.207V109.234C55.9066 108.067 52.4066 106.06 49.5532 106.06C46.6999 106.06 43.1999 108.074 43.1999 109.234V113.207",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5465 106.06C51.9332 106.06 53.5199 104.08 53.5199 101.633V100.16C53.5199 97.7133 51.9399 95.7334 49.5465 95.7334C47.1532 95.7334 45.5732 97.7133 45.5732 100.16V101.633C45.5732 104.08 47.1532 106.06 49.5465 106.06Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5532 131.973C46.6999 131.973 43.1999 133.987 43.1999 135.147V139.12C43.1999 140.287 46.6999 142.293 49.5532 142.293C52.4066 142.293 55.9066 140.28 55.9066 139.12V135.147C55.9066 133.98 52.4066 131.973 49.5532 131.973Z",
    fill: "#36A635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9066 139.12V135.147C55.9066 133.98 52.4066 131.973 49.5532 131.973C46.6999 131.973 43.1999 133.987 43.1999 135.147V139.12",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5465 131.973C51.9332 131.973 53.5199 129.994 53.5199 127.547V126.074C53.5199 123.627 51.9399 121.647 49.5465 121.647C47.1532 121.647 45.5732 123.627 45.5732 126.074V127.547C45.5732 129.994 47.1532 131.973 49.5465 131.973Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageContacts);
export default __webpack_public_path__ + "static/media/ManageContacts.fd7d1246f02638944e7917029deed7fd.svg";
export { ForwardRef as ReactComponent };